import styled from "styled-components";

const PhoneBannerStyled = styled.div`
    display: flex;
    margin-bottom: 30px;
    border-radius: 5px;
    position: relative;
    flex-direction: column;

    .titleContent {
        width: 100%;
        background: #008755;
        padding: 16px;
        font-size: 1.4rem;
        font-weight: 700;
        color: #fff;
        display: flex;
        align-items: center;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding-left: 100px;
    }

    .imgWrapper {
        position: absolute;
        left: 25px;
        top: 10px;
    }

    .infoContent {
        background: #e2f3e8;
        font-size: 1.2rem;
        font-weight: 400;
        padding: 16px;
        padding-left: 100px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-left-radius: 0px;
        color: #3d4543;
    }

    .linkWrapper {
        color: #006150;
        font-size: 1.2rem;
        font-weight: 700;
        text-decoration: underline;
        cursor: pointer;
        padding-left: 5px;
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        flex-direction: row;
        height: 96px;
        width: 700px;

        .titleContent {
            width: 43%;
            background: #008755;
            padding: 16px;
            font-size: 1.6rem;
            font-weight: 700;
            color: #fff;
            display: flex;
            align-items: center;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 0px;
            border-top-right-radius: 0px;
            padding-left: 16px;
        }

        .imgWrapper {
            position: absolute;
            left: 190px;
            top: 15px;
        }

        .infoContent {
            background: #e2f3e8;
            font-size: 1.2rem;
            font-weight: 400;
            padding: 16px;
            padding-left: 60px;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 0px;
            border-top-left-radius: 0px;
            color: #3d4543;
        }

        .linkWrapper {
            color: #006150;
            font-size: 1.2rem;
            font-weight: 700;
            text-decoration: underline;
            cursor: pointer;
            padding-left: 0px;
        }
    }
`;

export { PhoneBannerStyled };
